module.exports = __webpack_public_path__ + "static/media/man-laptop-img.b7cb183a.png";